<template>
	<div class="full detail_contaienr">
		<div class="full">
			<el-tabs v-model="activeName" type="border-card">
				<el-tab-pane label="模块" name="module">
					<vxe-table :data="moduleAuthData" size="mini" border height="450">
						<vxe-column type="seq" width="60"></vxe-column>
						<vxe-column field="onwer" title="模块名称"></vxe-column>
						<vxe-column field="authname" title="操作名称">
							<template #default="{ row }">
								<el-link style="font-size:12px;" type="primary" @click="modulecontrolledit(row)">
									{{row.authname}}
								</el-link>
							</template>
						</vxe-column>
						<vxe-column title="操作" width="100" show-overflow fixed="right" align="center">
							<template #default="{ row }">
								<vxe-button type="text" status="success" @click="authedit(row)">编辑授权</vxe-button>
							</template>
						</vxe-column>
					</vxe-table>
				</el-tab-pane>
				<el-tab-pane label="表单" name="form">
					<vxe-table :data="formAuthData" size="mini" border height="450">
						<vxe-column type="seq" width="60"></vxe-column>
						<vxe-column field="onwer" title="表单名称"></vxe-column>
						<vxe-column field="authname" title="操作名称">
							<template #default="{ row }">
								<el-link style="font-size:12px;" type="primary" @click="formcontrolledit(row)">
									{{row.authname}}
								</el-link>
								<vxe-button type="text" icon="el-icon-search" size="mini" @click="formpreview(row)">
								</vxe-button>
							</template>
						</vxe-column>
						<vxe-column title="操作" width="100" show-overflow fixed="right" align="center">
							<template #default="{ row }">
								<vxe-button type="text" status="success" @click="authedit(row)">编辑授权</vxe-button>
							</template>
						</vxe-column>
					</vxe-table>
				</el-tab-pane>
				<el-tab-pane label="流程" name="flow">
					<vxe-table :data="flowAuthData" size="mini" border height="450">
						<vxe-column type="seq" width="60"></vxe-column>
						<!-- <vxe-column field="authtype" title="授权类型"></vxe-column> -->
						<vxe-column field="onwer" title="所属表单"></vxe-column>
						<vxe-column field="authname" title="流程名称">
							<template #default="{ row }">
								<el-link style="font-size:12px;" type="primary" @click="flowedit(row)">
									{{row.authname}}
								</el-link>
							</template>
						</vxe-column>
						<vxe-column title="操作" width="100" show-overflow fixed="right" align="center">
							<template #default="{ row }">
								<vxe-button type="text" status="success" @click="authedit(row)">编辑授权</vxe-button>
							</template>
						</vxe-column>
					</vxe-table>
				</el-tab-pane>
			</el-tabs>
		</div>
		<component :is="formModule.component" v-if="formModule.show" :name="formModule.name" :id="formModule.id"
			:controlltype="formModule.controlltype" :extra="formModule.extra" :foreingKey="formModule.foreingKey"
			@back="formBack" />
	</div>


</template>
<style scoped>
	.detail_contaienr {
		box-sizing: border-box;
		padding: 10px;
	}
</style>
<script>
	export default {
		name: '',
		props: {
			joblevelid: {
				type: Number,
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {
				activeName: 'module',
				moduleAuthData: [],
				formAuthData: [],
				flowAuthData: [],
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				},
			}
		},
		watch: {

		},
		created() {
			this.list()
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			list() {
				this.$api.auth.getTotalAuth({
					joblevelid: this.joblevelid,
					type:'joblevel'
				}).then((res) => {
					this.moduleAuthData = this.initlist(res.module)
					this.formAuthData = this.initlist(res.form)
					this.flowAuthData = this.initlist(res.flow)
				})
			},
			initlist(list) {
				list.forEach((item) => {
					let authFrom = []
					item.authfrom.forEach((_item) => {
						if (_item.type == 'joblevel') {
							if (!authFrom['authjoblevel']) {
								authFrom['authjoblevel'] = []
							}
							authFrom['authjoblevel'].push(window.systemMethods.getjoblevel(_item.id))
						}
					})
					for (let i in authFrom) {
						item[i] = authFrom[i].join('，')
					}
				})
				return list
			},
			modulecontrolledit(row) {
				this.$api.module.get(row.onwerid).then((e) => {
					import('@_system/components/forms/moudel/controll/form.vue').then((res) => {
						this.formModule = {
							component: res.default,
							name: 'modulecontroll',
							id: row.controllId,
							controlltype: 2,
							show: true,
							foreingKey: {
								moduleid: row.onwerid,
							},
							extra: {
								title: '模块操作 / ' + row.onwer + ' / ' + row.authname + '',
								toolbarbutton: e.toolbarbutton,
								operatebutton: e.operatebutton,
								listfield: e.listfield.listfield
							}
						}
					})
				})
			},
			formcontrolledit(row) {
				this.$api.form.get(row.onwerid).then((e) => {
					import('@_system/components/forms/form/controll/form.vue').then((res) => {
						this.formModule = {
							component: res.default,
							name: 'formcontroll',
							id: row.controllId,
							controlltype: 2,
							show: true,
							foreingKey: {
								formid: row.onwerid
							},
							extra: {
								title: '表单操作 / ' + row.onwer + ' / ' + row.authname + '',
								targetRule: e.rule
							}
						}
					})
				})
			},
			formpreview(row) {
				this.$api.form.get(row.onwerid).then((e) => {
					import('@_system/components/forms/form/preview.vue').then((res) => {
						this.formModule = {
							component: res.default,
							name: '',
							show: true,
							extra: {
								rule: e.rule,
								title: e.title,
								controll: JSON.parse(row.controll),
								controllname: row.authname
							}
						}
					})
				})

			},
			flowedit(row) {
				import('@_system/components/forms/form/flow/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'flow',
						id: row.controllId,
						show: true,
						foreingKey: {
							formid: row.onwerid
						},
						extra: {
							title: '流程 / ' + row.onwer + ' / ' + row.authname + '',
						},
						controlltype: 1,
					}
				})
			},
			authedit(row) {
				import('@_system/components/forms/auth/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'auth',
						id: row.controllId,
						show: true,
						extra: {
							title: row.authtype + '授权 / ' + row.onwer + ' / ' + row.authname + '',
							type: row.type,
						}
					}
				})
			},
			formBack() {
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
				this.customreload()
			},
			customreload() {
				this.list()
			}
		},
		components: {

		}
	}
</script>
